<template>
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3012_12356)">
      <path
        d="M1.5 5.16335L1.5 16.8991C1.5 17.8005 2.29063 18.5312 3.26593 18.5312H17.7341C18.7094 18.5312 19.5 17.8005 19.5 16.8991V5.16335C19.5 4.26197 18.7094 3.53125 17.7341 3.53125L3.26593 3.53125C2.29063 3.53125 1.5 4.26197 1.5 5.16335Z"
        stroke="#1D2329"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <path
        d="M5.76494 8.53066C5.06633 8.53066 4.5 9.09699 4.5 9.7956C4.5 10.4942 5.06633 11.0605 5.76494 11.0605C6.46355 11.0605 7.02989 10.4942 7.02989 9.7956C7.02989 9.09699 6.46355 8.53066 5.76494 8.53066Z"
        fill="#1D2329"
      />
      <path
        d="M10.4695 8.53261C9.77092 8.53261 9.20459 9.09895 9.20459 9.79756C9.20459 10.4962 9.77092 11.0625 10.4695 11.0625C11.1681 11.0625 11.7345 10.4962 11.7345 9.79756C11.7345 9.09895 11.1681 8.53261 10.4695 8.53261Z"
        fill="#1D2329"
      />
      <path
        d="M15.1757 8.53066C14.4771 8.53066 13.9108 9.09699 13.9108 9.7956C13.9108 10.4942 14.4771 11.0605 15.1757 11.0605C15.8743 11.0605 16.4407 10.4942 16.4407 9.7956C16.4407 9.09699 15.8743 8.53066 15.1757 8.53066Z"
        fill="#1D2329"
      />
      <path
        d="M5.76494 13.1029C5.06634 13.1029 4.5 13.6693 4.5 14.3679C4.5 15.0665 5.06634 15.6328 5.76494 15.6328C6.46355 15.6328 7.02989 15.0665 7.02989 14.3679C7.02989 13.6693 6.46355 13.1029 5.76494 13.1029Z"
        fill="#1D2329"
      />
      <path
        d="M10.4709 13.1049C9.77227 13.1049 9.20593 13.6712 9.20593 14.3698C9.20593 15.0684 9.77227 15.6348 10.4709 15.6348C11.1695 15.6348 11.7358 15.0684 11.7358 14.3698C11.7358 13.6712 11.1695 13.1049 10.4709 13.1049Z"
        fill="#1D2329"
      />
      <path
        d="M15.1757 13.1029C14.4771 13.1029 13.9108 13.6693 13.9108 14.3679C13.9108 15.0665 14.4771 15.6328 15.1757 15.6328C15.8743 15.6328 16.4407 15.0665 16.4407 14.3679C16.4407 13.6693 15.8743 13.1029 15.1757 13.1029Z"
        fill="#1D2329"
      />
      <path
        d="M19.3834 6.10352H1.96899"
        stroke="#1D2329"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M5.87903 3.83943V1"
        stroke="#1D2329"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M10.6761 3.83943V1"
        stroke="#1D2329"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M15.4747 3.83943V1"
        stroke="#1D2329"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M1.5 6.53125V4.90026C1.5 4.14435 2.29086 3.53125 3.26593 3.53125L17.7341 3.53125C18.7091 3.53125 19.5 4.14435 19.5 4.90026V6.53125L1.5 6.53125Z"
        fill="#1D2329"
      />
    </g>
    <defs>
      <clipPath id="clip0_3012_12356">
        <rect width="20" height="20" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup></script>

<style scoped>
  /* Add custom styles if needed */
</style>
